import { pushAnalyticsEvent, pushEventToDataLayer } from "@ottatech/analytics";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import { analyticsFields, BatchOptions } from "../JobDeck/BatchOptions";

import { DesktopContent } from "./DesktopContent";
import { MobileContent } from "./MobileContent";

import { JobCardType } from ".";

import { Job, UserJobPreferences } from "schema";
import { jobProperties } from "utils/analytics/jobProperties";

export const WIDESCREEN_BREAK_POINT = 769;

interface JobContentProps {
  job: Job.Fragment;
  user?: UserJobPreferences.CurrentUser;
  type: JobCardType;
  batchDetails?: BatchOptions;
  publicJob?: boolean;
  toggleKeyboardShortcuts?: (enable: boolean) => void;
}

export function JobContent({
  job,
  user,
  type,
  batchDetails,
  publicJob = false,
  toggleKeyboardShortcuts,
}: JobContentProps): React.ReactElement {
  const isWideScreen = useMediaQuery({ minWidth: WIDESCREEN_BREAK_POINT });
  const [otherJobsExpanded, setOtherJobsExpanded] = useState(false);
  const handleExpandOtherJobs =
    type !== JobCardType.dashboard
      ? () => setOtherJobsExpanded(true)
      : undefined;

  useEffect(() => {
    pushAnalyticsEvent({
      eventName: "Candidate Viewed Job",
      context:
        type === JobCardType.jobDeck
          ? "Job Deck"
          : type === JobCardType.dashboard
          ? "Dashboard"
          : type === JobCardType.public
          ? "Public"
          : "Application",
      publicJob: type === JobCardType.public,
      applyViaOtta: job.acceptsInternalApplications,
      postedDirectly: !job.originalUrl,
      ottaCertified: job.company.ottaCertified,
      ...(batchDetails && analyticsFields(batchDetails)),
      ...jobProperties(job),
    });

    pushEventToDataLayer({
      event: "Candidate Viewed Job",
      context:
        type === JobCardType.jobDeck
          ? "Job Deck"
          : type === JobCardType.dashboard
          ? "Dashboard"
          : type === JobCardType.public
          ? "Public"
          : "Application",
      ...jobProperties(job),
    });

    // Only fire this useEffect if the job id has changed, not if the reference to the job has changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [job.id]);

  return isWideScreen ? (
    <DesktopContent
      job={job}
      user={user}
      otherJobsExpanded={otherJobsExpanded}
      expandOtherJobs={handleExpandOtherJobs}
      publicJob={publicJob}
      applicationView={type === JobCardType.application}
      toggleKeyboardShortcuts={toggleKeyboardShortcuts}
    />
  ) : (
    <MobileContent
      job={job}
      user={user}
      otherJobsExpanded={otherJobsExpanded}
      expandOtherJobs={handleExpandOtherJobs}
      publicJob={publicJob}
    />
  );
}
